<template>
  <div id="billing-details-modal">
    
    <memlist-modal size="lg" ref="transactions-details">
      <m-row>
        <m-col cols="6" >
          <div class="bottom-alignment">
            <strong>{{ $t('MEMBER.NUM_ROWS') }}:</strong> {{ total_rows }}
          </div>

        </m-col>
        <m-col cols="6">
          <div class="d-sm-flex justify-content-end align-items-right align-bottom w-100 mb-2">

            <memlist-pagination 
              :per_page="per_page" 
              :total_rows="total_rows" 
              @page-changed="current_page = $event"
              @per-page-changed="per_page = $event"
            />

          </div>
        </m-col>
      </m-row>

      <m-row>
        <m-col lg="12">

          <memlist-ajax-table
            id="transactions-table"
            :fields="headers"
            :items="ajax_pagination"
            :per_page="per_page"
            :current_page="current_page"
            @sort-changed="on_sort_changed"
            ref="transactions-table"
          >
          
          </memlist-ajax-table>
        </m-col>
      </m-row>
    </memlist-modal>

  </div>
</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'CustomerBillingTransactionListModal',
  components: {
    
  },
  mixins: [ toasts ],
  props: ['type','ths_invoice_id'],
  data() {
    return {
      order_by_dir: 'desc',
      order_by_col: 'id',
      per_page: 100,
      total_rows: 0,
      current_page: 1,
      services: [],
    };
  },
  watch: {
    
    type: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.services = [];

        switch (this.type) {
          case 'SMS': {
            this.services = ['sinch'];
            break;
          }
          case 'SPAR': {
            this.services = ['spar'];
            break;
          }
          case 'INVOICE': {
            this.services = ['manual_payment','bg','memlist_invoice'];
            break;
          }
          case 'ONLINE_PAYMENT': {
            this.services = ['swish','epassi','stripe'];
            break;
          }
          case 'BANKID': {
            this.services = ['bankid'];
            break;
          }
          
        }

        if (this.$refs['transactions-table']) {
          this.$refs['transactions-table'].refresh();
        }
        
      },
      immediate: true,
    },
    
    currentCompanyId(newValue, oldvalue) {
      
    },
    currentPeriodId(newValue, oldvalue) {
      
    }
  },
  async mounted() {
  
  },
  computed: {
    
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'isTHS']),

    headers() {
      return [
        {
          label: this.$t('TRANSACTION.ID'),
          sortable: true,
          key: 'id',
          tdClass: 'td-short',
          thClass: 'td-short',
        },
        {
          label: this.$t('TRANSACTION.CREATED_AT'),
          sortable: true,
          key: 'created_at',
          tdClass: 'td-short3',
          thClass: 'td-short3',
          formatter: (_, __, item) => {
            return dayjs(item.created_at).format('YYYY-MM-DD HH:mm');
          },
        },
        {
          label: this.$t('TRANSACTION.SERVICE'),
          sortable: true,
          key: 'service',
          tdClass: 'td-short3',
          thClass: 'td-short3',
          formatter: (_, __, item) => {
            return this.$t('TRANSACTION.SERVICES.' + (item.service || 'NONE').toUpperCase());
          },
        },
        {
          label: this.$t('TRANSACTION.AMOUNT'),
          sortable: true,
          key: 'amount',
          tdClass: 'td-short3',
          thClass: 'td-short3'
        },
        {
          label: this.$t('TRANSACTION.THS_FEE'),
          sortable: true,
          key: 'ths_fee',
          tdClass: 'td-short2',
          thClass: 'td-short2'
        },
        
      ];
    }
  },

  methods: {

    show() {
      this.$refs['transactions-details'].show();
    },

    hide() {
      this.$refs['transactions-details'].hide();
    },

    filter_invoice_id() {
      if (this.ths_invoice_id) {
        return `&ths_invoice_id=${this.ths_invoice_id}`;
      }

      return '';
    },

    on_sort_changed(sortChanged) {

      if (sortChanged.sortBy === '') {
        this.order_by_col = sortChanged.sortBy;
      }
      else {
        this.order_by_col = sortChanged.sortBy;
        this.order_by_dir = sortChanged.sortDesc ? 'desc' : 'asc';
      }
    },

    ajax_pagination: function(ctx, callback) {

      const vm = this;
      let params = {
        pageNo: ctx.current_page,
        pageSize: ctx.per_page,
        flag: 0,
        po: vm.searchOrderNumber,
        styNum: vm.searchStyleNumber
      };

      axios
        .get(`/transaction/billing?page=${this.current_page}&limit=${this.per_page}&order_by_col=${this.order_by_col}&dir=${this.order_by_dir}&services=${encodeURIComponent('[' + this.services.map(x => `"${x}"`).join(',') + ']')}${this.filter_invoice_id()}`)
        .then(res => {
          this.total_rows = res.data.count;
          var arr = res.data.transactions;

          callback(arr || []);
        })
        .catch(err => {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.UNABLE_GET_DATA'));
          console.error('pagination get error', err);
        });

      return null;
    },

  },
  
};
</script>
